// Barrel for the guides content cluster. One file per guide (filename === slug).
// The visible "Updated" byline AND Article schema dateModified both read from this
// merged `updated` field — a single source of truth backed by guide-dates.json.
import dates from "../guide-dates.json";
import g0 from "./fire-alarm-system-design-basics.js";
import g1 from "./nfpa-72-explained.js";
import g2 from "./smoke-vs-heat-detectors.js";
import g3 from "./preparing-for-a-fire-alarm-inspection.js";
import g4 from "./fire-alarm-wiring-and-circuits.js";
import g5 from "./pull-station-placement.js";
import g6 from "./voltage-drop-calculation.js";
import g7 from "./battery-standby-calculation.js";
import g8 from "./commercial-fire-alarm-troubleshooting.js";
import g9 from "./clearing-fire-alarm-ground-faults.js";
import g10 from "./data-center-fire-alarm-commissioning.js";
import g11 from "./notification-appliance-strobe-spacing.js";
import g12 from "./voice-evacuation-intelligibility.js";
import g13 from "./class-a-vs-class-b-circuits.js";
import g14 from "./wireless-fire-alarm-systems-nfpa72.js";
import g15 from "./acceptance-testing-vs-commissioning.js";

const RAW = [g0, g1, g2, g3, g4, g5, g6, g7, g8, g9, g10, g11, g12, g13, g14, g15];

export const GUIDES = RAW.map((g) => ({ ...g, updated: dates[g.slug] ?? g.updated }));
export const GUIDE_MAP = Object.fromEntries(GUIDES.map((g) => [g.slug, g]));

// Editorial byline / reviewer for E-E-A-T (author + reviewedBy in schema + visible byline + author box).
// SINGLE SOURCE OF TRUTH — edit here only. Fill `licenses` with real, publishable credentials
// (e.g. "NICET Level III — Fire Alarm Systems", "Texas Fire Alarm Planning Superintendent"); never invent them.
export const EDITORIAL = {
  author: "Ryan Pollard",
  authorShortTitle: "Fire Alarm Project Manager",
  authorTitle: "Fire Alarm Project Manager · Founder of Fire Alarm Blueprint Trainer and the FireAlarmBT YouTube channel",
  licenses: ["Texas Fire Alarm Installation License"],
  authorUrl: "https://firealarmbt.com/",
  sameAs: ["https://www.youtube.com/@FireAlarmBT"],
  bio: "Ryan Pollard is a Texas-licensed Fire Alarm Project Manager with 4 years in the field, specializing in data-center fire alarm systems. He built Fire Alarm Blueprint Trainer to turn that field experience into plain-language training for technicians, designers and students — interactive blueprints, circuit labs, exam prep and real-world case studies. Every article is written from field practice and checked against NFPA 72 and NFPA 70 before publishing.",
  reviewer: "Ryan Pollard",
  reviewerCredentials: "reviewed against NFPA 72 & NFPA 70 principles",
};

// "Name, Credential 1 · Credential 2" for bylines; falls back to the title line when no licenses are set.
export const AUTHOR_LINE = [EDITORIAL.authorShortTitle, ...EDITORIAL.licenses].filter(Boolean).join(" · ") || EDITORIAL.authorTitle;

// schema.org Person for Article.author / reviewedBy
export const AUTHOR_SCHEMA = {
  "@type": "Person",
  name: EDITORIAL.author,
  jobTitle: EDITORIAL.authorTitle,
  url: EDITORIAL.authorUrl,
  sameAs: EDITORIAL.sameAs,
  ...(EDITORIAL.licenses.length ? { hasCredential: EDITORIAL.licenses.map((c) => ({ "@type": "EducationalOccupationalCredential", name: c })) } : {}),
};
